import { Card, CardContent } from "@altimateai/lego";
import styles from "./styles.module.scss";
import { BotImage } from "@assets/icons";
import { ReactNode } from "react";

interface RobotBGCardProps {
  children: ReactNode;
}

const RobotBGCard = ({ children }: RobotBGCardProps): JSX.Element => {
  return (
    <Card className="al-mt-6">
      <CardContent className="al-relative al-pt-4">
        <div className={styles.content}>{children}</div>
        <BotImage className={styles.bot_image} />
        <div className={styles.background}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="184"
            height="100%"
            viewBox="0 0 184 248"
            fill="none"
          >
            <path
              d="M413.675 -18.9897C475.807 80.788 438.09 216.524 329.432 284.186C220.774 351.847 -78.5518 435.624 20.1902 226.034C118.932 16.4444 -4.22448 -9.47988 104.433 -77.1413C213.091 -144.803 351.544 -118.767 413.675 -18.9897Z"
              fill="url(#paint0_linear_8622_1359)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_8622_1359"
                x1="112.93"
                y1="21.1516"
                x2="497.009"
                y2="-25.6795"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#096CD7" />
                <stop offset="1" stopColor="#D9C1FF" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </CardContent>
    </Card>
  );
};

export { RobotBGCard };
